// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortLists = (list: any[], key1: string, key2?: string) => {
  if (key2) {
    return list.sort((a, b) => (a[key1] || a[key2]).localeCompare(b[key1] || b[key2]));
  }

  return list.sort((a, b) => (a[key1] || '').localeCompare(b[key1] || ''));
};
